export default __webpack_public_path__ + "static/media/team1.5552cd09.svg";